<template lang="pug">
	section(:class="{'force-mobile': forceMobile}")
		form
			.row
				.pr-5.with-border(:class="{'col-md-6': !forceMobile,'col-md-12': forceMobile }")
					//- .social-container
					//- 	a.social-button.google(@click="goToGoogle()")
					//- 		.logo
					//- 			img(:src="`${$store.state.config.s3ResourceHost}/images/google-logo.svg`" alt="")
					//- 		.text
					//- 			| USER YOUR GOOGLE EMAIL
					//- .divider-container
					//- 	span.text OR USE YOUR EMAIL
					//- 	.line

					div
						label
							| Email
						sfc-input-v2.text-input(v-model="email" type="text" :error="emailError" :error-message="emailErrorMessage" inputmode="email" @input="isValid()" :autocomplete="`new-password`" name="email" @focus="focusEmail = true" @blur="focusEmail = false")
						span.disclaimer(:class="{'focus-disclaimer': focusEmail, 'pull-up': emailError}")
							| {{disclaimer}}
				.col-md-6.pl-lg-5.bordered-left.d-none.d-md-block.right-column
					h3.title {{objCopy.title}}
					ul.mt-lg-none
						li(v-for="copy in objCopy.list")
							span.mr-3.float-left
								svg(xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13")
									path(fill="#19CC95" fill-rule="nonzero" d="M5.6 8L2.4 4.8 0 7.2l5.6 5.6L16 2.4 13.6 0z")
							p.overflow-hidden
								| {{copy}}
							.clearfix

			.continue-button
				sfc-button.mr-4(:blue="false" :backArrow="true" @click="back()")
				sfc-button(text="CONTINUE" :blue="true" :continue-arrow="true" @click="next" :loading="loading")

</template>
<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.with-border
	border-right: 1px solid sfc-pale-gray
	@media (max-width: 767px)
		border-right: 0


.disclaimer
	font-size: body-font-size-xs
	color: sfc-pale-gray
	margin-top: 5px
	display: block
	&.focus-disclaimer
		color: body-font-color
	&.pull-up
		margin-top: -5px
.text-input
	>>> input
		@media(max-width: 575px)
			font-size: body-font-size-md !important

.show-hide
label
	font-size: body-font-size-sm

h3
	margin-top 10px
	margin-bottom 30px
ul
	padding 0
	margin 0
	list-style none
	li
		margin-bottom 30px
.overflow-hidden
	overflow hidden
.continue-button
	margin-top: 60px
.cursor-pointer
	cursor pointer


.social-container
	margin-top: 20px
	.social-button
		color: #fff
		border: 1px solid
		overflow: hidden
		border-radius()
		cursor: pointer
		display: block
		&:hover
			color: #fff
		.logo
			display: inline-block
			width: 50px
			text-align: center
			padding: 9px 0
		&.facebook
			border-color: #2353b1
			background-color: #3e71d5
			.logo
				background-color: #275ec7
				border-right: 1px solid #2353b1
		&.google
			margin-top: 30px
			border-color:  #4d8cf5
			background-color: #4c8bf5
			.logo
				background-color: #fff
		.text
			padding-left: 20px
			display: inline-block
			@media(max-width: 767px)
				font-size: body-font-size

.divider-container
	margin-top: 30px
	margin-bottom: 30px
	text-align: center
	.text
		font-size: body-font-size-xs
		color: sfc-gray-dark
		background-color: #fff
		padding: 0 15px
	.line
		margin-top: -15px
		border-top: 1px solid sfc-pale-gray-light


section.force-mobile
	@media (min-width: 768px)
		.with-border
			border-right: 0

		.right-column
			display: none !important


</style>

<script>

import SfcButton from '@/common/components/sfc-button'
import SfcInputV2 from '@/common/components/inputs/v2/textbox'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	props: {
		forceMobile: {
			default: false
		}
	},

	components:{
		SfcButton,
		SfcInputV2
	},

	data() {
		return {
			emailError: false,
			emailErrorMessage: null,
			email: null,
			progressLength: 15,
			message: "",
			loading: false,
			validateOnChange: false,
			objCopy: {title: "Get FREE access to:", list: ["Track your child’s 529 plan growth and performance", "Notifications to help you better manage your child’s 529 plan", "Tips on how to accelerate the growth of your child’s 529 plan"]},
			disclaimer: "Your information will not be shared",
			focusEmail: false,
			facebookUrl: "",
			googleUrl: ""
		}
	},

	mounted(){
		this.$root.$on('nextStepChange', this.objCopyChange)
	},

	methods: {
		goToFacebook(){
			let userData = {
				type_of_user: this.$store.state.collegeSavingsUserOnboarding['type_of_user'],
				children: this.$store.state.collegeSavingsUserOnboarding['children'],
				next_step_v3: this.$store.state.collegeSavingsUserOnboarding['next_step_v3']
			}
			if (this.$store.state.collegeSavingsUserOnboarding['state'] && this.$store.state.collegeSavingsUserOnboarding['state'].string_id){
				userData.state_id = this.$store.state.collegeSavingsUserOnboarding['state'].string_id
			}
			let data = encodeURI(btoa(JSON.stringify(userData)))
			this.facebookUrl = `/auth/facebook?action=register&user_data=${data}`
			return window.location.href = this.facebookUrl
		},
		goToGoogle(){
			let userData = {
				type_of_user: this.$store.state.collegeSavingsUserOnboarding['type_of_user'],
				children: this.$store.state.collegeSavingsUserOnboarding['children'],
				next_step_v3: this.$store.state.collegeSavingsUserOnboarding['next_step_v3']
			}
			if (this.$store.state.collegeSavingsUserOnboarding['state'] && this.$store.state.collegeSavingsUserOnboarding['state'].string_id){
				userData.state_id = this.$store.state.collegeSavingsUserOnboarding['state'].string_id
			}
			let data = encodeURI(btoa(JSON.stringify(userData)))
			this.googleUrl = `/auth/google_oauth2?action=register&user_data=${data}`
			return window.location.href = this.googleUrl
		},
		objCopyChange(){
			const objCopy = {
				title: "Access the Savings Center",
				list: [
					"Learn about 529 plans and other savings options",
					"Project college costs and how much you'll need to save",
					"Compare 529 plans and start saving"
				]
			}
			this.objCopy = objCopy
		},
		isValid(){
			let valueToReturn = true

			if(this.validateOnChange){
				this.emailError = false
				const emailRegex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

				if (!emailRegex.test(this.email)) {
					valueToReturn = false
					this.emailError = true
					this.emailErrorMessage = "Please enter a valid email"
				}
			}

			return valueToReturn
		},

		back(){
			this.$emit('next', -1*this.progressLength, "How can we help you today?", "sfc-how-can-we-help-you-today", false, true)
		},

		login(){
			// Track Heap
			if (heap) {
				heap.addUserProperties({"email": this.email});
			}

			this.$emit(
				'next',
				90,
				"Log In to your account",
				"sfc-log-in-to-your-account",
				{
					progressLength: this.progressLength,
					title: "Create your account",
					component: "sfc-create-your-account"
				}
			)
		},

		async signup(){
			this.validateOnChange = true
			if(!this.isValid()){
				return
			}

			// Track Heap
			if (heap) {
				heap.addUserProperties({"email": this.email});
			}

			this.emailErrorMessage = ""
			this.emailError = false
			this.loading = true
			let collegeSavingsUser = undefined

			// //SPA GraphQL mutation
			const query = `
				mutation{
					college_savings_user_v3(
						type_of_user: "${this.$store.state.collegeSavingsUserOnboarding['type_of_user']}"
						next_step_v3: "${this.$store.state.collegeSavingsUserOnboarding['next_step_v3']}"
						state_id: "${this.$store.state.collegeSavingsUserOnboarding['state'].string_id}"
						email: "${this.email}"
					){
						id
						next_step_v3
						type_of_user
						children{
							id
							name
							age
						}
						state{
							id
							name
							slug
						}
						email
						primary_id
					}
				}
			`
			try {
				await this.$httpService.graphql(query)
			} catch (e) {
				this.emailErrorMessage = "There was an error. Please, try again."
				this.emailError = true
				this.loading = false
				return
			}


			try {
				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: this.email})
			} catch (error) {
				this.loading = false
			}
			collegeSavingsUser = {
				state: this.$store.state.collegeSavingsUserOnboarding.state,
				type_of_user: this.$store.state.collegeSavingsUserOnboarding.type_of_user,
				childrenCount: parseInt(this.$store.state.collegeSavingsUserOnboarding.childrenCount),
				youngerAge: this.$store.state.collegeSavingsUserOnboarding.youngerAge,
				olderAge: this.$store.state.collegeSavingsUserOnboarding.olderAge,
				email: this.email,
				next_step_v3: this.$store.state.collegeSavingsUserOnboarding.next_step_v3
			}

			const collegeSavingsUserString = JSON.stringify(collegeSavingsUser)
			this.$cookies.set("savings-center-info", collegeSavingsUserString, {
				// path: '/',
				// domain: 'savingforcollege.com',
				maxAge: 365 * 24 * 60 * 60
			})

			if(this.email){
				const today = new Date();
				const currentYear = today.getFullYear();

				let birthYearYounger = ""
				let birthYearOlder = ""
				let oldString = ""
				birthYearYounger = currentYear - parseInt(collegeSavingsUser.youngerAge)
				let youngString = `birth_year_younger_child: "${birthYearYounger}", `
				if (collegeSavingsUser.olderAge && collegeSavingsUser.olderAge != ""){
					birthYearOlder = currentYear - parseInt(collegeSavingsUser.olderAge)
					oldString = `birth_year_older_child: "${birthYearOlder}",`
				}
				else {
					oldString = `birth_year_older_child: "${birthYearYounger}",`
					youngString = ""
				}
				const query2 = `
					mutation{
						track_data(email: "${this.email}", user_type: "${collegeSavingsUser.type_of_user}", state_id: "${collegeSavingsUser.state.string_id}", childage: "${collegeSavingsUser.youngerAge}", number_of_children: ${collegeSavingsUser.childrenCount}, ${youngString} ${oldString} savings_center: true, csjourney: "${this.$store.state.csjourney}", csgifting: "${this.$store.state.csgifting}")
					}
					`
				try {
					await this.$httpService.graphql(query2)
				} catch (e) {
					console.log("mailchimp update attribute failed")
				}

			}

			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "Registration - next", "Register", 0)
			let url

			if(!this.$store.state.collegeSavingsUserOnboarding['next_step_v3']){
				this.$store.state.collegeSavingsUserOnboarding['next_step_v3'] = 'learn'
			}
			if (this.$store.state.collegeSavingsUserOnboarding['next_step_v3'] == 'learn'){
				url = 'learn/how-much-will-college-cost'
			}else{
				url = this.$store.state.collegeSavingsUserOnboarding['next_step_v3']
			}
			this.$parent.closeModal();
			return this.$router.push('/savings-center/' + url)
		},

		next(){
			this.signup()
		}
	}

}
</script>
